import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/AddNews.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const AddNewCourse = () => {

    const initialFormData = {
        title:'',
        field_taxo_courses: "_none",
        field_apply_form_desc:'',
        field_application_key_name:'',
        field_weight:'',
        summary: '',
        body: '',
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        field_header_image:'',
        field_image:'',
        field_file_attachments:[],
        field_next_start_day:'',
        field_next_start_month:'',
        field_url_restriction:[],
        field_course_logo:'',
        placements: [{ placement_page: '', placement_sort_order: '1' }],
    };

    const [formData,setFormData] =useState(initialFormData);
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [useRichEditor, setUseRichEditor] = useState(true);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

    const [imageUploadError, setImageUploadError] = useState('');
    const [tempImage, setTempImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null); 
    const [logoUploadError, setLogoUploadError] = useState('');
    const [tempLogo, setTempLogo] = useState(null);
    const [selectedLogo, setSelectedLogo] = useState(null);
    const [attachmentUploadError, setAttachmentUploadError] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]); 
    const [uploadedFiles, setUploadedFiles] = useState([]); 
    const [fileInputKey, setFileInputKey] = useState(0);
    const [courses, setCourses] = useState([]);
    const [pages, setPages] = useState([]);
     const [backenderrorMessage, setBackendErrorMessage] = useState('');
    const [disabled, setDisabled] = useState(false);
    const domainName = window.location.hostname;
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');  
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {uid} = useParams();
    var {username} = useParams();
    if(location.state) {
    uid = location.state;
    }
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;


    useEffect(() => {
        Promise.all([
            getplacementlist(),
            getcourselist(),
            getuserloggedinroles(),
        ]).then(() => {
            setIsLoading(false);
        })
    }, []);
    
    const months = [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" }
    ];
    const days = Array.from({ length: 31 }, (_, i) => {
    const day = String(i + 1).padStart(2, "0");
    return { value: day, label: day };
    });

    const urlRestriction = [
    {value: configData.RSMWW_DOMAIN, label: "SportsManagementWorldwide.com"},
    {value: configData.RSMWW_AGENCY_DOMAIN, label: "SMWWAgency.com"},
    {value: configData.RSMWW_SCOUT_DOMAIN, label: "SMWWScout.com"}
    ]

     async function getcourselist() {
    
         try {
            const response = await fetch(
                app_url+'report/getajaxcourselist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourses(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
     async function getplacementlist() {
    
         try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }
        
  }

    async function getuserloggedinroles() {

        try {
        setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",

                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
            setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
    }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    
}   

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const handleTempImageChange = (e) => {
        const files = Array.from(e.target.files);
        const file = files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024;
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        if (errors.length > 0) {
            const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
            setImageUploadError(errorHTML);
            e.target.value = '';
            setTempImage(null);
            return;
        }

        setImageUploadError(''); // Clear previous error
        const objectUrl = URL.createObjectURL(file);
        setTempImage({
            file,
            preview: objectUrl
        });
    };
    const handleImageUploadClick = () => {
        if (tempImage) {
            setSelectedImage(tempImage);
            setFormData(prev => ({
            ...prev,
            field_image: tempImage.file
            }));
            setImageUploadError(''); // Clear error on successful upload
        }
    };

    // Remove image
    const removeImage = () => {
        setSelectedImage(null);
        setTempImage(null);
        setFormData(prev => ({
            ...prev,
            field_image: "",
        }));
    };

    const imageValue = selectedImage ? selectedImage.file : formData.field_image;
    const fileName =
        imageValue && typeof imageValue === "object" && imageValue.name
        ? imageValue.name
        : typeof imageValue === "string"
        ? imageValue.split("/").pop()
        : "";

    const handleTempLogoChange = (e) => {
    const files = Array.from(e.target.files);
    const file = files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const maxSize = 128 * 1024 * 1024; // 128 MB
    const errors = [];

    if (!validTypes.includes(file.type)) {
        errors.push('Allowed file types: png, gif, jpg, jpeg.');
    }

    if (file.size > maxSize) {
        errors.push('File must be less than 128 MB.');
    }

    if (errors.length > 0) {
        const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
        setLogoUploadError(errorHTML);
        e.target.value = '';
        setTempLogo(null);
        return;
    }

    setLogoUploadError(''); // Clear previous error
    const objectUrl = URL.createObjectURL(file);
    setTempLogo({
        file,
        preview: objectUrl
    });
};

const handleLogoUploadClick = () => {
    if (tempLogo) {
        setSelectedLogo(tempLogo);
        setFormData(prev => ({
            ...prev,
            field_course_logo: tempLogo.file // Assuming your backend field is field_course_logo
        }));
        setLogoUploadError(''); // Clear error on successful upload
    }
};

const removeLogo = () => {
    setSelectedLogo(null);
    setTempLogo(null);
    setFormData(prev => ({
        ...prev,
        field_course_logo: "",
    }));
};

// --- LOGO VALUE & FILENAME RESOLVERS ---

const logoValue = selectedLogo ? selectedLogo.file : formData.field_course_logo;

const logoFileName =
    logoValue && typeof logoValue === "object" && logoValue.name
    ? logoValue.name
    : typeof logoValue === "string"
    ? logoValue.split("/").pop()
    : "";

// --- FILE ATTACHMENTS HANDLERS ---

const handleTempAttachmentChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // Part B's strict conditions preserved
    const allowedExtensions = ['jpg', 'jpeg', 'gif', 'png', 'txt', 'doc', 'xls', 'pdf', 'ppt', 'pps', 'odt', 'ods', 'odp'];
    const maxSize = 2 * 1024 * 1024; // 2 MB from Part B
    
    const validFiles = [];
    const invalidFiles = [];

    files.forEach(file => {
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const isValidSize = file.size <= maxSize;
        const isValidType = allowedExtensions.includes(fileExtension);

        if (isValidSize && isValidType) {
            validFiles.push({
                file,
                preview: URL.createObjectURL(file)
            });
        } else {
            invalidFiles.push(file);
        }
    });

    if (invalidFiles.length > 0) {
        const names = invalidFiles.map(f => f.name).join(', ');
        const errorHTML = `The selected file${invalidFiles.length > 1 ? 's' : ''} <em>${names}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>jpg, jpeg, gif, png, txt, doc, xls, pdf, ppt, pps, odt, ods, odp</em> and must be under 2 MB.`;
        
        setAttachmentUploadError(errorHTML);
        setFileInputKey(prev => prev + 1); // Reset input field on error
        setSelectedFiles([]);
    } else {
        setAttachmentUploadError(''); // Clear previous errors
        setSelectedFiles(validFiles);
    }
};

const handleAttachmentUploadClick = () => {
    if (selectedFiles.length > 0) {
        // Append new files to the list
        setUploadedFiles(prev => [...prev, ...selectedFiles]);
        
        setFormData(prev => ({
            ...prev,
            field_file_attachments: [
                ...(Array.isArray(prev.field_file_attachments) ? prev.field_file_attachments : []),
                ...selectedFiles.map(sf => sf.file)
            ]
        }));
        
        setAttachmentUploadError(''); 
        setSelectedFiles([]);
        setFileInputKey(prev => prev + 1); // Reset file input UI
    }
};

const removeAttachment = (index) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    setFormData(prev => ({
        ...prev,
        field_file_attachments: Array.isArray(prev.field_file_attachments)
            ? prev.field_file_attachments.filter((_, i) => i !== index)
            : []
    }));
};


const attachmentValue = selectedFiles ? selectedFiles.file : formData.field_file_attachments;

const attachmentFileName =
    attachmentValue && typeof attachmentValue === "object" && attachmentValue.name
    ? attachmentValue.name
    : typeof attachmentValue === "string"
    ? attachmentValue.split("/").pop()
    : "";
    const formatFileSize = (size) => {
        if (size < 1024) return size + " Bytes";
        else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
        else return (size / (1024 * 1024)).toFixed(2) + " MB";
    };

    const getImageSrc = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value; // already a URL from backend
        if (value.preview) return value.preview; // wrapper object { file, preview, name }
        if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
        if (value instanceof File) return URL.createObjectURL(value); // plain File object
        return "";
    };
    const handleAddPlacement = () => {
        setFormData((prev) => ({
        ...prev,
        placements: [...prev.placements, { placement_page: '', placement_sort_order: '1' }],
        }));
    };

    const handleDeletePlacement = (index) => {
        const updated = formData.placements.filter((_, i) => i !== index);
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handlePlacementChange = (index, field, value) => {
        const updated = [...formData.placements];
        updated[index][field] = value;
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handlePreviewClick = () => {
        const {
        title,
        summary,
        body,
        field_taxo_courses,
        field_apply_form_desc,
        field_application_key_name,
        field_weight,
        field_image,
        field_meta_title,
        field_meta_keywords,
        field_meta_description, 
        field_course_logo,
        field_next_start_day,
        field_next_start_month,
        field_url_restriction,
        } = formData;

        const newErrors = {};
        if (!title.trim()) {
            newErrors.title = "Title field is required.";
            window.scrollTo(0, 0);
        }
           if (!field_weight.trim()) {
            newErrors.field_weight = "Weight(lbs) field is required.";
            window.scrollTo(0, 0);
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setPreviewFields(false);
            return;
        }

        const cleanedSummary = cleanHtmlOutput(summary);
        const cleanedBody = cleanHtmlOutput(body);

        const hasSummary = cleanedSummary && cleanedSummary.trim() !== '';
        let trimmedHtml = '';

        if (hasSummary) {
            trimmedHtml = cleanedSummary;
        } else if (cleanedBody.includes('<!--break-->')) {
            trimmedHtml = cleanedBody.split('<!--break-->')[0];
        } else {
            const tmp = document.createElement('div');
            tmp.innerHTML = cleanedBody;
            // const plainText = (tmp.textContent || tmp.innerText || "").trim();

            // let snippet = plainText.split('. ')[0];
            // if (snippet.length < 20) {
            //     snippet = plainText.substring(0, 200);
            // }

            // trimmedHtml = snippet ? `<p>${snippet}</p>` : '';
            trimmedHtml = '';
        }

        setPreviewData({
            title,
            summary: hasSummary ? cleanedSummary : '',
            trimmed: trimmedHtml,
            body: cleanedBody,
            field_taxo_courses,
            field_apply_form_desc,
            field_application_key_name,
            field_weight,
            field_meta_title,
            field_meta_keywords,
            field_meta_description,
            field_image,
            field_course_logo,
            field_next_start_day,
            field_next_start_month,
            field_url_restriction: Array.isArray(field_url_restriction) &&
            field_url_restriction.length === 0
            ? ''
            : field_url_restriction,
        });

        setErrors({});
        setPreviewFields(true);
        window.scrollTo(0, 0);
    };

    const cleanHtmlOutput = (html) => {
        if (!html || typeof html !== 'string') return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : cleaned.trim();
    };

    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };

      const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData(prev => {
      if (type === "checkbox" && Array.isArray(prev[name])) {
        return {
          ...prev,
          [name]: checked
            ? [...prev[name], value]
            : prev[name].filter(v => v !== value),
        };
      }

      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
        newErrors.title = "Title field is required.";
        window.scrollTo(0, 0);
        }
        if (!formData.field_weight.trim()) {
        newErrors.field_weight = "Weight(lbs) field is required.";
        window.scrollTo(0, 0);
        } else if (!/^\d+$/.test(formData.field_weight.trim())) {
            newErrors.field_weight = "Only numbers are allowed in Weight (lbs).";
            window.scrollTo(0, 0);
        }
        return newErrors;
    };

    const inputStyle = {
        title: {
        border: errors.title ? '2px solid red' : '1px solid #777'
        },
        field_weight:{
        border: errors.field_weight ? '2px solid red' : '1px solid #777'
        }
    };


    const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);
    setPreviewFields(false);
      setPreviewFields(false);
        setImageUploadError("");
        setLogoUploadError("");
        setAttachmentUploadError("");
    window.scrollTo(0, 0);

    if (Object.keys(validationErrors).length > 0) return;

    // 1. Show "Saving..." on the submit button and disable interactive elements
    setFormData(prevState => ({
        ...prevState,
        button_name: "Saving..."
    }));
    setDisabled(true);

    const cleanedSummary = cleanHtmlOutput(formData.summary);
    const cleanedBody = cleanHtmlOutput(formData.body); // Fallback to state body

    // 2. Instantiate FormData
    const postData = new FormData();

    // 3. Append media files to postData (Check if state exists and holds a valid browser File)
    if (selectedImage && selectedImage.file) {
        postData.append('field_image', selectedImage.file);
    }
    if (selectedLogo && selectedLogo.file) {
        postData.append('field_course_logo', selectedLogo.file);
    }
    if (selectedFiles && selectedFiles.file) {
        postData.append('field_file_attachments', selectedFiles.file);
    }

    // 4. Normalize array-based fields so they don't break on the backend 
    const updatedFormData = {
        ...formData,
        summary: cleanedSummary,
        body: cleanedBody,
        field_url_restriction: Array.isArray(formData.field_url_restriction) &&
            formData.field_url_restriction.length === 0
            ? ''
            : formData.field_url_restriction,
        // If no file was successfully uploaded/selected, clear this array back to empty string
        field_file_attachments: selectedFiles && selectedFiles.file
            ? selectedFiles.file.name 
            : (Array.isArray(formData.field_file_attachments) && formData.field_file_attachments.length === 0 ? '' : formData.field_file_attachments)
    };

    console.log("Submitted data:", updatedFormData);
    postData.append('formData', JSON.stringify(updatedFormData));

    try {
        // 5. Send POST request (replace fetch url wrapper as needed)
        const response = await fetch(app_url + 'coursepages/addnewcourse', { // Adjust backend path if needed
            method: 'POST',
            body: postData,
        });

        const data = await response.json();

        if (data.data.msg === "Success") {  
            setFormData(initialFormData); 
            
            setDisabled(false);
            
            // Redirect smoothly to view details
            window.location.href= "/" + data.data.url_slug;
        } else {
            // Re-enable in case backend validation issues/errors bubble up
            setDisabled(false);
            setBackendErrorMessage(data.data.text);
            setFormData(prevState => ({
                ...prevState,
                button_name: "Save"
            }));
        }
    } catch (error) {
        console.error("Error during form submission: ", error);
        setDisabled(false);
        setFormData(prevState => ({
            ...prevState,
            button_name: "Save"
        }));
    }
};

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet>
                        <title>
                            Create Course | SMWW 
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="agency-news-create-preview">
                            {PreviewFields && (
                            <>
                                <div
                                    className="messages status"
                                    style={{
                                        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                                        backgroundPosition: '10px 10px',
                                    }}
                                >
                                    The trimmed version of your post shows what your post looks like when promoted
                                    to the main page or when exported for syndication.
                                    <span>
                                        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                                        fine-tune where your post gets split.
                                    </span>
                                </div>

                                <div className="preview-container">
                                    {/* Trimmed version */}
                                    <div className="preview-trimmed">
                                        <h4 className="preview-heading">
                                            Preview trimmed version
                                        </h4>

                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                <span style={{color: "#2C99D2"}}>{previewData?.title}</span>
                                            </h2>

                                            {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                                                <div
                                                    className="preview-body-content"
                                                    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {/* Full version */}
                                    <div className="preview-full">
                                        <h4 className="preview-heading">
                                            Preview full version
                                        </h4>
                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                {/* <strong>Body:</strong> */}
                                            </h2>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                __html: previewData.body || '',
                                                }}
                                            />
                                            <div className="email-meta">
                                            {previewData.field_taxo_courses && (
                                                <p><strong>Course Category:</strong> {previewData.field_taxo_courses}</p>
                                            )}
                                            {previewData.field_application_key_name && (
                                                <p><strong>Application Key:</strong> {previewData.field_application_key_name}</p>
                                            )}
                                            {previewData.field_apply_form_desc && (
                                                <p><strong>Form Description:</strong> {previewData.field_apply_form_desc}</p>
                                            )}
                                            {previewData.field_weight && (
                                                <p><strong>Weight(lbs):</strong> {previewData.field_weight}</p>
                                            )}
                                             {previewData.field_meta_title && (
                                            <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
                                            {previewData.field_meta_keywords && (
                                            <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
                                            {previewData.field_meta_description && (
                                            <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}

                                            {/* Next Start Date Schedule */}
                                            {(previewData.field_next_start_month || previewData.field_next_start_day) && (
                                                <p>
                                                    <strong>Next Start Date: </strong> 
                                                    {previewData.field_next_start_month || 'None'} - {previewData.field_next_start_day || 'None'}
                                                </p>
                                            )}
                                                {previewData.field_image && (
                                                    <div>
                                                        <strong>Image:</strong><br />
                                                        <img 
                                                        src={getImageSrc(previewData.field_image)} 
                                                        alt="Preview" 
                                                        style={{ height: "100px", width: "100px", marginTop: "5px" }} 
                                                        />
                                                    </div>
                                                )}
                                                    {previewData.field_course_logo && (
                                                    <div>
                                                        <strong>Course Logo:</strong><br />
                                                        <img 
                                                        src={getImageSrc(previewData.field_course_logo)} 
                                                        alt="Preview" 
                                                        style={{ height: "100px", width: "100px", marginTop: "5px" }} 
                                                        />
                                                    </div>
                                                )}
                                                {previewData.field_url_restriction && (
                                                    <p>
                                                    <strong>URL Restriction:</strong>{" "}
                                                    {urlRestriction.filter(opt => previewData.field_url_restriction.includes(opt.value)).map(opt => opt.label).join(", ")}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            )}
                        </div>
                        <div className="agency-news-create-container">
                            {Object.values(errors).some(msg => !!msg) && (
                                <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                >
                                    <ul>
                                    {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                        <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className="form-item">
                                        <label htmlFor="edit-title">
                                        Title  
                                        <span className="form-required" title="This field is required.*">*</span>
                                        </label>
                                        <input
                                        type="text" 
                                        id="edit-title" 
                                        name="title" 
                                        maxLength={255}
                                        onChange={handleChange} 
                                        value={formData.title}
                                        style={inputStyle.title}
                                        />
                                    </div>
                                    <div className="form-item">
                                    <label htmlFor="edit-field-taxo-courses">Courses </label>
                                  <select
                                            id="edit-field-taxo-courses"
                                            name="field_taxo_courses"
                                            className="form-select"
                                            value={formData.field_taxo_courses}
                                            onChange={handleChange}
                                        >
                                            <option value="_none">- None -</option>

                                            {courses.map((item, index) => (
                                                <option
                                                    key={index}
                                                    value={item.course_name}
                                                >
                                                    {item.course_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-item  fieldmeta-description">
                                        <label>Description for preview tile</label>
                                        <textarea
                                        name="field_apply_form_desc"
                                        value={formData.field_apply_form_desc}
                                        onChange={handleChange}
                                        
                                        />
                                        <div className="grippie" style={{
                                        background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                        }}>   
                                        </div>
                                    </div>
                                    <div className="form-item">
                                    {/* In React, 'for' becomes 'htmlFor' */}
                                    <label htmlFor="edit-field-application-key-name">
                                        Application Key Name
                                    </label>
                                    
                                    <input 
                                        className="text-full form-text" 
                                        type="text" 
                                        id="edit-field-application-key-name" 
                                        name="field_application_key_name" 
                                        size={60} 
                                        maxLength={255}
                                        value={formData.field_application_key_name}
                                        onChange={handleChange}
                                    />
                                    </div>
                                    <div className="form-item">
                                    <label htmlFor="edit-field-weight-und-0-value">
                                        Weight (lbs) <span className="form-required" title="This field is required.">*</span>
                                    </label>
                                    
                                    <input 
                                        type="text" 
                                        id="edit-field-weight" 
                                        name="field_weight" 
                                        size={12} 
                                        maxLength={10} 
                                        value={formData.field_weight}
                                        onChange={handleChange}
                                        style={inputStyle.field_weight}
                                    />

                                    
                                    </div>

                                    
                                    <div>
                                        <div>
                                            {showSummary && (
                                                <div className="form-item">
                                                    <label htmlFor="create_summary">
                                                        Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                                    </label>
                                                    <>
                                                        <Editor 
                                                        value={formData.summary} 
                                                        onChange={(e) => {
                                                            const newValue = e?.target?.value || '';
                                                            setFormData((prev) => ({ ...prev, summary: newValue }));
                                                        }}
                                                        />
                                                    </>
                                                    <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                </div>
                                            )}
                                    
                                            <div className="form-item">
                                                <label htmlFor="create_body">
                                                    Body
                                                    {!showSummary && (
                                                        <span>
                                                            (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                Edit Summary
                                                            </a>)
                                                        </span>
                                                    )}
                                                </label>
                                                <>
                                                    {useRichEditor ? (
                                                        <> 
                                                            <Editor 
                                                                containerProps={{ style: { resize: 'vertical', height:'300px' } }} 
                                                                value={formData.body} 
                                                                onChange={handleEditorChange}

                                                            />  
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                                Switch to plain text editor
                                                            </a>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <textarea
                                                                id="create_body"
                                                                rows="20"
                                                                value={formData.body} 
                                                                // onChange={e => onEditorChange('body', e.target.value)}
                                                                onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) } 
                                                            />
                                                            <div 
                                                                className="grippie" 
                                                                style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                            >
                                                            </div>
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                                Switch to rich text editor
                                                            </a>
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                        </div>
                                         <div className="form-item -field-meta-title">
                                    <label htmlFor="meta_title">Meta Title</label>
                                    <input 
                                    type="text" 
                                    id="meta_title" 
                                    name="field_meta_title" 
                                    value={formData.field_meta_title} 
                                    onChange={handleChange}  
                                    maxLength={255}
                                    /> 
                                </div>
                                <div className="form-item field-meta-keywords">
                                    <label htmlFor="meta_keywords">Meta Keywords</label>
                                    <input 
                                    type="text" 
                                    id="meta_keywords" 
                                    name="field_meta_keywords" 
                                    value={formData.field_meta_keywords} 
                                    onChange={handleChange}
                                    maxLength={255}
                                    /> 
                                </div>
                                <div className="form-item  fieldmeta-description">
                                    <label>Meta Description</label>
                                    <textarea
                                    name="field_meta_description"
                                    value={formData.field_meta_description}
                                    onChange={handleChange}
                                    
                                    />
                                    <div className="grippie" style={{
                                    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                    }}>   
                                    </div>
                                </div>
<fieldset className="form-wrapper" id="edit-file-attachments" style={{ border: '1px solid #ccc', padding: '15px', marginBottom: '15px', borderRadius: '4px' }}>
    <legend style={{ fontWeight: 'bold', fontSize: '1.1em' }}></legend>

    <div className="fieldset-wrapper">
        <label>FILE ATTACHMENTS</label>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
            Add new files
        </label>
        
        {/* Error Message Panel */}
        {attachmentUploadError && (
            <div
                className="set-message-error error-message-padding"
                style={{
                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`,
                    marginBottom: '10px'
                }}
            >
                <div 
                    style={{ 
                        color: '#8c2e0b',
                        backgroundColor: '#fef5f1',
                        width: '80%',
                        borderRadius: '5px',
                        padding: '5px 10px'
                    }}
                    dangerouslySetInnerHTML={{ __html: attachmentUploadError }}
                />
            </div>
        )}

        {/* File Input Controls Group */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
            <input
                type="file"
                key={fileInputKey} // Force reset control from Part A
                id="edit-file-attachment-upload"
                name="edit_file_attachment_upload"
                multiple // Allows multiple selection from Part A
                accept=".jpg,.jpeg,.gif,.png,.txt,.doc,.xls,.pdf,.ppt,.pps,.odt,.ods,.odp"
                onChange={handleTempAttachmentChange}
                style={{ border: '1px solid #ccc', padding: '4px' }}
            />
            <input
                type="button"
                value="Upload"
                className="form-submit"
                disabled={selectedFiles.length === 0}
                onClick={handleAttachmentUploadClick}
            />
        </div>

        {/* Render List of Uploaded Files */}
        {uploadedFiles.map((att, index) => (
            <div key={index} className="edit-attachment-container" style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="image-info">
                    <img
                        className="file-icon"
                        alt="File icon"
                        src={typeof getFileIcon === 'function' ? getFileIcon(att.file.name) : ''}
                        style={{ marginRight: '8px', verticalAlign: 'middle' }}
                    />
                    <a
                        href={att.preview}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="image-name-link"
                    >
                        {att.file.name}
                    </a>
                    <span className="image-size" style={{ marginLeft: '10px', color: '#666' }}>
                        ({(att.file.size / 1024).toFixed(2)} KB)
                    </span>
                </div>
                <input
                    type="button"
                    value="Remove"
                    className="form-submit"
                    style={{ marginLeft: '10px' }}
                    onClick={() => removeAttachment(index)}
                />
            </div>
        ))}

        {/* Database Existing Fallback Link Array Check (If populated via string URL fallback initially) */}
        {uploadedFiles.length === 0 && formData.field_file_attachments && typeof formData.field_file_attachments === 'string' && (
            <div className="edit-attachment-container" style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="image-info">
                    <img
                        className="file-icon"
                        alt="File icon"
                        src={typeof getFileIcon === 'function' ? getFileIcon(formData.field_file_attachments.split("/").pop()) : ''}
                        style={{ marginRight: '8px', verticalAlign: 'middle' }}
                    />
                    <a
                        href={formData.field_file_attachments}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="image-name-link"
                    >
                        {formData.field_file_attachments.split("/").pop()}
                    </a>
                </div>
                <input
                    type="button"
                    value="Remove"
                    className="form-submit"
                    onClick={() => removeAttachment(0)}
                />
            </div>
        )}

        {/* Static Instructional Guidance Text */}
        <div className="description" style={{ color: '#555', fontSize: '0.9em', marginTop: '10px' }}>
            Files must be less than <b>2 MB</b>.<br />
            Allowed file types: <b>jpg jpeg gif png txt doc xls pdf ppt pps odt ods odp</b>.
        </div>
        
        <div style={{ clear: "both" }}></div>
    </div>
</fieldset>
                                <div class="form-item">
                                <label for="edit-field-header-image">Header Image </label>
                                <input class="text-full form-text" type="text" id="edit-field-header-image-und-0-value" name="field_header_image" value={formData.field_header_image} onChange={handleChange} size="60" maxlength="100"/>
                                </div>
                                        <div>
                                            <label>Image</label>
                                            {imageUploadError && (
                                                <div
                                                        className="set-message-error error-message-padding"
                                                        style={{
                                                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                        }}
                                                    >
                                            <div 
                                                style={{ color: '#8c2e0b',
                                                    backgroundColor: '#fef5f1',
                                                    marginBottom: '10px', 
                                                    width: '80%',
                                                    borderRadius: '5px' 
                                                }}
                                                dangerouslySetInnerHTML={{ __html: imageUploadError }}
                                                >                           
                                            </div>
                                            </div>
                                            )}
                                            {selectedImage ? (
                                                // Case 1: New image selected
                                                <div className="edit-agent-image-container">
                                                <img alt="Uploaded" src={selectedImage.preview} width="90" height="100" />
                                                <div className="image-info">
                                                    <img
                                                    className="file-icon"
                                                    alt="File icon"
                                                    src={getFileIcon(selectedImage.file.name)}
                                                />
                                                    <a
                                                    href={selectedImage.preview}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                    >
                                                    {selectedImage.file.name}
                                                    </a>
                                                    <span className="image-size">
                                                    ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                                    </span>
                                                </div>
                                                </div>
                                            ) : formData.field_image ? (
                                                // Case 2: Image already saved (URL string from backend)
                                                <div className="edit-scout-report-image-container">
                                                <img
                                                    alt="Uploaded"
                                                    src={formData.field_image}
                                                    width="90"
                                                    height="100"
                                                />
                                                <div className="image-info">
                                                    <a
                                                    href={formData.field_image}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                    >
                                                    {fileName}
                                                    </a>
                                                </div>
                                                </div>
                                            ) : (
                                                // Case 3: No image yet → show upload input
                                                <div>
                                                <input
                                                    type="file"
                                                    id="edit-agent-photo-upload"
                                                    name="edit_agent_photo_upload"
                                                    accept="image/*"
                                                    onChange={handleTempImageChange}
                                                />
                                                <input
                                                    type="button"
                                                    value="Upload"
                                                    className="form-submit"
                                                    onClick={handleImageUploadClick}
                                                />
                                                </div>
                                            )}

                                            {(selectedImage || formData.field_image) && (
                                                <input
                                                type="button"
                                                value="Remove"
                                                className="form-submit"
                                                onClick={removeImage}
                                                />
                                            )}

                                            {!formData.field_image && !selectedImage && (
                                                <div className="description">
                                                Files must be less than <b>128 MB</b>.<br />
                                                Allowed file types: <b>png gif jpg jpeg</b>.
                                                </div>
                                            )}
                                            <div style={{clear: "both"}}></div>
                                        </div>
                                <div className="form-item">
                                <label htmlFor="edit-field-call-back-day">Day </label>
                                <div className="call-back-field">
                                <select 
                                    className="" 
                                    id="edit-field-call-back-day" 
                                    name="field_next_start_day"
                                    value={formData.field_next_start_day}
                                    onChange={handleChange}
                                >
                                    <option value="">-None-</option>
                                    {days.map((d) => (
                                    <option key={d.value} value={d.value}>
                                        {d.label}
                                    </option>
                                    ))}  
                                </select>
                                </div>
                            </div>
                              <div className="form-item">
                            <label htmlFor="edit-field-call-back-month">Month </label>
                            <div className="call-back-field">
                            <select 
                                className="" 
                                id="edit-field-call-back-month" 
                                name="field_call_back_month"
                                value={formData.field_call_back_month}
                                onChange={handleChange}
                            >
                                <option value="">-None-</option>
                                {months.map((m) => (
                                    <option key={m.value} value={m.value}>
                                    {m.label}
                                    </option>
                                ))}
                            </select>
                            </div>
                        </div>
                         <div>
                    <label>URL Restriction </label>
                    <div className="blog-url-restrition-field">
                      {urlRestriction.map((url) => (
                        <label style={{fontWeight:"normal"}} key={url.value}>
                          <input
                            type="checkbox"
                            name="field_url_restriction"
                            value={url.value}
                            checked={formData.field_url_restriction.includes(url.value)}
                            onChange={handleChange}
                          />
                          {url.label}
                        </label>
                      ))}
                    </div>
                  </div>
                    <div style={{marginTop:"10px",marginBottom:"10px"}}>
                                            <label>Course Logo</label>
                                            
                                            {/* Error Message Section */}
                                            {logoUploadError && (
                                                <div
                                                    className="set-message-error error-message-padding"
                                                    style={{
                                                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                    }}
                                                >
                                                    <div 
                                                        style={{ 
                                                            color: '#8c2e0b',
                                                            backgroundColor: '#fef5f1',
                                                            marginBottom: '10px', 
                                                            width: '80%',
                                                            borderRadius: '5px' 
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: logoUploadError }}
                                                    />
                                                </div>
                                            )}

                                            {/* Preview/Info Section */}
                                            {selectedLogo ? (
                                                // Case 1: New logo chosen but not saved to DB yet
                                                <div className="edit-agent-image-container">
                                                    <img alt="Uploaded Logo Preview" src={selectedLogo.preview} width="90" height="100" />
                                                    <div className="image-info">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(selectedLogo.file.name)}
                                                        />
                                                        <a
                                                            href={selectedLogo.preview}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="image-name-link"
                                                        >
                                                            {selectedLogo.file.name}
                                                        </a>
                                                        <span className="image-size">
                                                            ({(selectedLogo.file.size / 1024).toFixed(2)} KB)
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : formData.field_course_logo ? (
                                                // Case 2: Logo already exists in backend/formData
                                                <div className="edit-scout-report-image-container">
                                                    <img
                                                        alt="Course Logo"
                                                        src={formData.field_course_logo}
                                                        width="90"
                                                        height="100"
                                                    />
                                                    <div className="image-info">
                                                        <a
                                                            href={formData.field_course_logo}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="image-name-link"
                                                        >
                                                            {logoFileName}
                                                        </a>
                                                    </div>
                                                </div>
                                            ) : (
                                                // Case 3: No logo is set or selected -> Show input element
                                                <div>
                                                    <input
                                                        type="file"
                                                        id="edit-course-logo-upload"
                                                        name="edit_course_logo_upload"
                                                        accept="image/*"
                                                        onChange={handleTempLogoChange}
                                                    />
                                                    <input
                                                        type="button"
                                                        value="Upload"
                                                        className="form-submit"
                                                        onClick={handleLogoUploadClick}
                                                    />
                                                </div>
                                            )}

                                            {/* Remove Action Button */}
                                            {(selectedLogo || formData.field_course_logo) && (
                                                <input
                                                    type="button"
                                                    value="Remove"
                                                    className="form-submit"
                                                    onClick={removeLogo}
                                                />
                                            )}

                                            {/* Instructions Panel */}
                                            {!formData.field_course_logo && !selectedLogo && (
                                                <div className="description">
                                                    Files must be less than <b>128 MB</b>.<br />
                                                    Allowed file types: <b>png gif jpg jpeg</b>.
                                                </div>
                                            )}
                                            
                                            <div style={{ clear: "both" }}></div>
                                        </div>
<fieldset 
    className="form-wrapper" 
    style={{
        border: "1px solid #ccc", 
        padding: "15px 20px", 
        marginBottom: "15px",
        fontFamily: "sans-serif"
    }}
>
    {/* Fieldset Legend Header */}
    <legend style={{ padding: "0 5px", fontWeight: "bold", fontSize: "12px", color: "#333" }}>
        
    </legend>

    <div className="editprofile-fieldset-wrapper">
        <label>PLACEMENTS</label>
        <table 
            style={{
                width: "100%",
                borderCollapse: "collapse",
                backgroundColor: "white",
                border: "1px solid #ccc",
                fontSize: "11px"
            }} 
            className="placements-table"
        >
            <thead>
                <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                    <th style={{ 
                        width: '70%', 
                        padding: '6px 10px', 
                        textAlign: 'left', 
                        fontWeight: 'bold', 
                        color: '#333',
                        textTransform: 'uppercase',
                        borderRight: '1px solid #ccc'
                    }}>
                        Page
                    </th>
                    <th style={{ 
                        width: '15%', 
                        padding: '6px 10px', 
                        textAlign: 'left', 
                        fontWeight: 'bold', 
                        color: '#333',
                        textTransform: 'uppercase',
                        borderRight: '1px solid #ccc'
                    }}>
                        Sort Order
                    </th>
                    <th style={{ 
                        width: '15%', 
                        padding: '6px 10px', 
                        textAlign: 'center', 
                        fontWeight: 'bold', 
                        color: '#333',
                        textTransform: 'uppercase'
                    }}>
                        Delete
                    </th>
                </tr>
            </thead>
            <tbody>
                {formData.placements.map((placement, index) => (
                    <tr key={index} style={{ borderBottom: index < formData.placements.length - 1 ? "1px solid #ccc" : "none" }}>
                        {/* Page Select Column */}
                        <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                            <select
                                className="placement-select"
                                name={`placement_page_${index}`}
                                value={placement.page}
                                onChange={(e) =>
                                    handlePlacementChange(index, 'placement_page', e.target.value)
                                }
                                style={{
                                    width: "100%",
                                    padding: "4px",
                                    border: "1px solid #ccc",
                                    borderRadius: "2px",
                                    fontSize: "12px",
                                    boxSizing: "border-box"
                                }}
                            >
                                <option value="">Select a page</option>
                                {pages.length > 0 && (
                                    <>
                                        {pages.map((item) => (
                                            <option key={item['id']} value={item['id']}>
                                                {item['title']}
                                            </option>
                                        ))}
                                    </>
                                )}
                            </select>
                        </td>

                        {/* Sort Order Select Column */}
                        <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                            <select
                                name={`placement_sort_order_${index}`}
                                className="adduser-form-select"
                                value={placement.order}
                                onChange={(e) =>
                                    handlePlacementChange(index, 'order', e.target.value)
                                }
                                style={{
                                    width: "100%",
                                    maxWidth: "60px",
                                    padding: "4px",
                                    border: "1px solid #ccc",
                                    borderRadius: "2px",
                                    fontSize: "12px"
                                }}
                            >
                                {[...Array(50)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        {i + 1}
                                    </option>
                                ))}
                            </select>
                        </td>

                        {/* Delete Button Column */}
                        <td style={{ padding: '10px', textAlign: 'center' }}>
                            <button
                                type="button"
                                className='quick-links-reg-button form-submit'
                                onClick={() => handleDeletePlacement(index)}
                                
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

        {/* Add Placement Link */}
        <div style={{ marginTop: "12px" }}>
            <a
                className="add-placement-link"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    handleAddPlacement();
                }}
                style={{
                    color: "#0071B8",
                    textDecoration: "none",
                    fontWeight: "bold",
                    fontSize: "12px"
                }}
                onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
            >
                + Add
            </a>
        </div>
    </div>
</fieldset>
                                       
                                    </div>
                               
                               
                                    <div className="form-actions form-wrapper" id="create-actions">
                                        <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp;
                                        <input 
                                            type="button" 
                                            id="edit-preview"  
                                            value="Preview" 
                                            className="form-submit" 
                                            onClick={()=> {
                                            handlePreviewClick();
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="right">
                        {domainName === configData.RSMWW_DOMAIN && 
                            <SalespersonSidebar/>
                        } 
                        {((domainName === configData.RSMWW_SCOUT_DOMAIN || domainName === configData.RSMWW_AGENCY_DOMAIN) && 
                            (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || 
                            userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
                            userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                        ) ? 
                            (<SalespersonSidebar/>
                            ) : (
                            <>
                            <h1>Quick Links</h1>    
                            <ul className="user-opt-menu" style={{paddingLeft:"0px"}}>       
                                <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                                <li>
                                <a href="/smww_pay">
                                    <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>
                            </ul>  
                            </>
                        )} 
                    </div>
                </div>
            )}
        </>
    );
};
export default AddNewCourse;